import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { useSidebar } from '../../contexts/SidebarContext';
import { useTheme } from '../../contexts/ThemeContext';

interface LayoutProps {
    children: React.ReactNode;
    showSidebar?: boolean;
    sidebarContent?: React.ReactNode;
    sidebarCollapsedContent?: React.ReactNode;
    mainContentClass?: string;
    footerClass?: string;
    showFooter?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ 
    children, 
    showSidebar = true, 
    sidebarContent,
    sidebarCollapsedContent,
    mainContentClass,
    footerClass,
    showFooter = true
}) => {
    const { isCollapsed } = useSidebar();
    const { darkMode } = useTheme();
    
    const sidebarWidth = isCollapsed ? 64 : 256; // 16 = 4rem, 256 = 16rem
    const mainClass = mainContentClass || `flex-1 transition-all duration-300`;
    const footerClassFinal = footerClass || '';

    return (
        <div className={`min-h-screen transition-colors duration-300 ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
            <Header />
            <div className="flex pt-14">
                {showSidebar && (
                    <Sidebar collapsedContent={sidebarCollapsedContent}>
                        {sidebarContent}
                    </Sidebar>
                )}
                <main 
                    id="main-content" 
                    className={mainClass}
                    style={{ 
                        marginLeft: showSidebar ? `${sidebarWidth}px` : '0',
                        transition: 'margin-left 300ms ease-in-out',
                        paddingBottom: showFooter ? '64px' : '0',
                        width: '100%',
                        maxWidth: '100%',
                        overflowX: 'hidden'
                    }}
                >
                    {children}
                </main>
            </div>
            {showFooter && (
                <Footer 
                    footerClass={footerClassFinal} 
                    sidebarWidth={showSidebar ? sidebarWidth : 0} 
                />
            )}
        </div>
    );
};

export default Layout;
